import React from 'react';
import * as ReactDOM from 'react-dom/client';
import {ApolloClient, InMemoryCache, ApolloProvider} from '@apollo/client';
import MyApp from './App';
import 'dayjs/locale/zh-cn';
import locale from 'antd/locale/zh_CN';
import {ConfigProvider} from "antd";
import {split, HttpLink} from '@apollo/client';
import {getMainDefinition} from '@apollo/client/utilities';
import {GraphQLWsLink} from '@apollo/client/link/subscriptions';
import {createClient} from 'graphql-ws';
import {LogtoProvider, LogtoConfig, useLogto} from '@logto/react';
import {APIURL, SERVER} from "./config";
import {App} from 'antd';

Date.prototype.format = function (fmt) {
    var o = {
        "M+": this.getMonth() + 1,                 //月份
        "d+": this.getDate(),                    //日
        "h+": this.getHours(),                   //小时
        "m+": this.getMinutes(),                 //分
        "s+": this.getSeconds(),                 //秒
        "q+": Math.floor((this.getMonth() + 3) / 3), //季度
        "S": this.getMilliseconds()             //毫秒
    };

    if (/(y+)/.test(fmt)) {
        fmt = fmt.replace(RegExp.$1, (this.getFullYear() + "").substr(4 - RegExp.$1.length));
    }

    for (var k in o) {
        if (new RegExp("(" + k + ")").test(fmt)) {
            fmt = fmt.replace(
                RegExp.$1, (RegExp.$1.length == 1) ? (o[k]) : (("00" + o[k]).substr(("" + o[k]).length)));
        }
    }

    return fmt;
}
Date.prototype.toLocaleString = function () {
    return new Date(this).format("yyyy年MM月dd日 hh:mm:ss")
}
Date.prototype.toLocaleDateString = function () {
    return new Date(this).format("yyyy年MM月dd日")
}

// Supported in React 18+
const root = ReactDOM.createRoot(document.getElementById('root'));
const config = {
    endpoint: 'https://auth.relay.ac.cn/',
    appId: '6vXP97hmUUUb6dYZZ8Wm5',
    resources: ['https://gqrd.api'],
};
root.render(
    <LogtoProvider config={config}>
        <ConfigProvider locale={locale}>
            <App>
                <MyApp/>
            </App>
        </ConfigProvider>
    </LogtoProvider>
);
